import { render, staticRenderFns } from "./CashReceipt.vue?vue&type=template&id=8d83a9c6&"
import script from "./CashReceipt.vue?vue&type=script&lang=js&"
export * from "./CashReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports